document.addEventListener('livewire:navigated', function () {
    initializeSearchForm();

    function initializeSearchForm() {
        var componentContainerSelector = '.header-search-form';

        $(document).off('click.searchForm').on('click.searchForm', function (e) {
            if($(e.target).closest(componentContainerSelector).length === 0) {
                $(componentContainerSelector)
                    .removeClass('show')
                    .find('.search__results')
                    .addClass('d-none');
            }
        });

        $(componentContainerSelector).off('click.searchForm').on('click.searchForm', function (e) {
            var $component = $(this);
            var shouldShowDefaultResults = $component.data('show-default-results') !== false;
            var hasSearchValue = $.trim($component.find('.search__input').val()).length > 0;

            if (!hasSearchValue && !shouldShowDefaultResults) {
                $component.find('.search__results').addClass('d-none');
                $component.removeClass('show');
                return;
            }

            $component.find('.search__results').removeClass('d-none');
            $component.addClass('show');
        });
    }
});
